<template>
  <div v-if="intents && intents.length">
    <b-button
      v-for="(intent, index) in intents"
      v-bind:key="'action-btn-'+intent"
      variant="secondary"
      @click="select($event, intent)"
      :class="{
        'd-none': !showAllIntents && intents.length > displaySize && index > (displaySize - 1),
        'item-select-btn': !useIntents,
        'btn-outline-success': isOutlineButton(intent),
        'no-outline-btn': !isOutlineButton(intent),
        'position-relative': !useIntents
      }"
    >
      <span>{{getIntentLabel(intent)}}</span>
      <font-awesome-icon v-if="!useIntents" class="position-absolute" :icon="['fas', 'angle-right']"></font-awesome-icon>
    </b-button>
    <div v-if="intents.length > displaySize" class="more-options" @click.stop="showAllIntents = !showAllIntents">
      <hr class="more-options-separator d-block d-lg-none" />
      <span><template v-if="showAllIntents">Hide</template><template v-else>Show</template> More Options</span>
      <svg v-if="showAllIntents" xmlns="http://www.w3.org/2000/svg" width="13" height="8" viewBox="0 0 13 8" fill="none">
        <path d="M11.5 6.5L6.5 1.5L1.5 6.5" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <svg v-else xmlns="http://www.w3.org/2000/svg" width="13" height="8" viewBox="0 0 13 8" fill="none">
        <path d="M1.5 1.5L6.5 6.5L11.5 1.5" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
  </div>
</template>

<script>
import {IntentLabels} from '@/constants'
import {isPrimaryIntent} from '@/utils'

export default {
  name: 'SelectItemIntents',
  props: {
    intents: {
      type: Array,
      default: function() {
        return []
      }
    },
    useIntents: {
      type: Boolean,
      default: function() {
        return false
      }
    }
  },
  data: function() {
    return {
      showAllIntents: false
    }
  },
  computed: {
    displaySize: function() {
      return this.useIntents ? 3 : 2
    }
  },
  methods: {
    getIntentLabel: function(intent) {
      return IntentLabels[intent]
    },
    select: function(event, intent) {
      event.stopPropagation()
      this.$emit('select', intent)
    },
    isOutlineButton: function(intent) {
      return !isPrimaryIntent(intent) // for now all intents are outline buttons
    }
  }
}
</script>

<style scoped>

</style>
